import { render, staticRenderFns } from "./LabRequests.vue?vue&type=template&id=74901b9a&"
import script from "./LabRequests.vue?vue&type=script&lang=js&"
export * from "./LabRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports